/**
 * @generated SignedSource<<ad642f1c4af8bc1509f11c06a0963b9c>>
 * @relayHash e8ae7ab32189fb155478d43e63c3f190
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type srcRovoServiceAgentSettingsQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type srcRovoServiceAgentSettingsQuery$data = {
  readonly atlassianStudio_userSiteContext: {
    readonly isCustomAgentsAvailable?: boolean | null | undefined;
    readonly userPermissions?: {
      readonly isAbleToCreateAgents: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: string;
      readonly message?: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"settingsBreadcrumbsFragment">;
    } | null | undefined;
  } | null | undefined;
};
export type srcRovoServiceAgentSettingsQuery = {
  response: srcRovoServiceAgentSettingsQuery$data;
  variables: srcRovoServiceAgentSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCustomAgentsAvailable"
    },
    {
      "concreteType": "AtlassianStudioUserProductPermissions",
      "kind": "LinkedField",
      "name": "userPermissions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAbleToCreateAgents"
        }
      ]
    }
  ],
  "type": "AtlassianStudioUserSiteContextOutput"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "srcRovoServiceAgentSettingsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "settingsBreadcrumbsFragment"
              }
            ]
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "srcRovoServiceAgentSettingsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "default"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b",
    "metadata": {},
    "name": "srcRovoServiceAgentSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "31b851fb2037198c36030d97e7f1d665";

export default node;
